import axiosInstance from '../axios/axiosInstance';
import { getActiveCompanyId } from 'utils/companyContext';

const cid = () => getActiveCompanyId() || localStorage.getItem('companyId');

export const listOffboarding = async (companyId = cid()) =>
    (await axiosInstance.get(`/companies/${companyId}/offboarding`)).data;

export const getOffboarding = async (id, companyId = cid()) =>
    (await axiosInstance.get(`/companies/${companyId}/offboarding/${id}`)).data;

export const createOffboarding = async (payload, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/offboarding`, payload)).data;

export const updateOffboarding = async (id, payload, companyId = cid()) =>
    (await axiosInstance.patch(`/companies/${companyId}/offboarding/${id}`, payload)).data;

export const applyOffboarding = async (id, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/offboarding/${id}/apply`)).data;

export const updateOffboardingTask = async (id, taskId, isDone, companyId = cid()) =>
    (await axiosInstance.patch(`/companies/${companyId}/offboarding/${id}/tasks/${taskId}`, { isDone })).data;

export const rehireWorker = async (id, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/offboarding/${id}/rehire`)).data;

export const leaveFirm = async (payload = {}, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/leave-firm`, payload)).data;

export const closeCompany = async (payload = {}, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/close`, payload)).data;

export const removeCompanyFromFirm = async (companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/offboarding/remove-from-firm`)).data;

export const listFirmUsers = async () =>
    (await axiosInstance.get('/firms/mine/users')).data;

export const deactivateFirmUser = async (userId, payload = {}) =>
    (await axiosInstance.post(`/firms/mine/users/${userId}/deactivate`, payload)).data;

export const closeFirm = async (payload = {}) =>
    (await axiosInstance.post('/firms/mine/close', payload)).data;

export const listOffboardingTemplates = async (companyId = cid()) =>
    (await axiosInstance.get(`/companies/${companyId}/offboarding/templates`)).data;

export const saveOffboardingTemplate = async (payload, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/offboarding/templates`, payload)).data;

export const listCobraEvents = async (companyId = cid()) =>
    (await axiosInstance.get(`/companies/${companyId}/cobra`)).data;

export const saveCobraEvent = async (payload, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/cobra`, payload)).data;

export const updateCobraEvent = async (id, payload, companyId = cid()) =>
    (await axiosInstance.patch(`/companies/${companyId}/cobra/${id}`, payload)).data;

export const reassignManager = async (employeeId, managerEmployeeId, companyId = cid()) =>
    (await axiosInstance.post(`/companies/${companyId}/employees/${employeeId}/reassign-manager`, { managerEmployeeId })).data;

export const runDueOffboards = async () =>
    (await axiosInstance.post('/offboarding/run-due')).data;
